export function formatPercentage(value) {
    return value ? +value + "%" : "0.00%";
}

export function formatPercentageWithBrackets(value) {
    return value ? "(" + value + "%)" : "(0.00%)";
}

export function formatKPIPercentage(value) {
    if (value) {
        return value > 0 ? "+" + value + "%" : value + "%";
    }
    return "0.00%";
}